import React from 'react';
import { Report } from 'apiTypes';
import { PromptGroup, RecordDocuments } from 'types/candidateStories';
import PromptSummaryGeneralSection from './PromptSummaryGeneralSection';
import PromptSummaryRecordSection from './PromptSummaryRecordSection';

const CandidateStoryPromptSummary = ({
  candidateStories,
  selectedRecords,
  promptGroups,
}: {
  candidateStories: any;
  selectedRecords: Report[];
  promptGroups: PromptGroup[];
}) => {
  const summaryPromptItems = candidateStories.promptGroup?.content || {};
  const { general = {}, ...recordResponses } = summaryPromptItems;
  const generalDocuments = candidateStories.promptGroup?.general || {};
  const recordDocuments: RecordDocuments = {};

  Object.keys(candidateStories.promptGroup || {}).forEach(key => {
    if (key !== 'content' && key !== 'general') {
      recordDocuments[key] = candidateStories.promptGroup[key];
    }
  });

  return (
    <div data-testid='candidate-story-prompt-summary'>
      <PromptSummaryGeneralSection
        generalResponses={general}
        generalDocuments={generalDocuments}
        promptGroups={promptGroups}
      />
      <PromptSummaryRecordSection
        recordResponses={recordResponses}
        selectedRecords={selectedRecords}
        promptGroups={promptGroups}
        recordDocuments={recordDocuments}
      />
    </div>
  );
};

export default CandidateStoryPromptSummary;
